import React from 'react';
import PropTypes from 'prop-types';

export default class Loader extends React.Component {
  static propTypes = {
    loading: PropTypes.bool
  };

  render() {
    if (this.props.loading) {
      return (
        <div className="loader-container">
          <svg className="circle-loader progress" width="40" height="40">
            <circle cx="20" cy="20" r="15" />
          </svg>
        </div>
      );
    }
    return <div />;
  }
}



// WEBPACK FOOTER //
// ./js/components/widgets/Loader.js